import moment from 'moment';
import 'moment/locale/fi';
import React from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import MomentLocaleUtils from 'react-day-picker/moment';
import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { enableSubNavbar, setSubNavbar } from '../actions/navbar';
import { requestInstallationOrders, requestInstallationOrdersAll, SAVE_INSTALLATION_ORDERS_ALL } from '../actions/worklist';
import Button from '../components/forms/Button';
import Icon from '../components/forms/Icon';
import Input from '../components/forms/Input';
import Select from '../components/forms/Select';
import ExcelResult from '../components/worklist/ExcelResult';
import WorkTable from '../components/worklist/WorkTable';
import CloseIcon from '../images/close_red.png';
import NewIcon from '../images/new.png';
import store from '../store';
import './Main.css';
import './WorkList.css';

class WorkList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      limit: 25,
      isLastPage: false,
      isDataLoading: false,
      isExcelLoading: false,
      filter: {},
      lastUsedId: 0,
      filterFields: [],
      startDate: new Date(),
      endDate: new Date(),
    };
  }

  componentDidUpdate() {
    const {
      translate,
      setSubNavbar,
    } = this.props;

    setSubNavbar({
      title: [
        translate('navigation.worklist'),
      ],
    });
  }

  componentDidMount() {
    if (this.props.location.state !== undefined) {
      const { installationCode = null, installationDate = null } = this.props.location.state;
      this.startDateChanged(installationDate);
      this.endDateChanged(installationDate);

      setTimeout(() => {
        this.setState({
          filterFields: [
            {
              id: 0,
              value: 'shipmentId',
            },
            {
              id: 1,
              value: 'status',
            }],
        });

        document.getElementsByClassName('end-customer').item(0).value = 'shipmentId';
        document.getElementsByClassName('end-customer').item(1).value = 'status';
        document.getElementsByClassName('worklist-filter-field')[0].value = installationCode;
        document.getElementsByClassName('select_ready').item(1).value = 'WEB_TO_WEB_COMPLETED';

        this.generateFilterJson();
        this.performSearch(1);
      }, 200);
    } else {
      this.performSearch(1);
    }
  }

  componentWillUnmount() {
    this.cleanExcelStore();
  }

  cleanExcelStore = () => {
    store.dispatch({
      type: SAVE_INSTALLATION_ORDERS_ALL,
      installationOrdersAll: [],
    });
  };

  limitChanged = (evt) => {
    this.setState({
      limit: evt.currentTarget.value,
    }, () => this.performSearch(1));
  };

  startDateChanged = (date) => {
    const selectedDate = new Date(date);
    const getCurrentYear = new Date(selectedDate).getFullYear();
    const modifiedSelectedDate = new Date(getCurrentYear, selectedDate.getMonth(), selectedDate.getDate());
    let { filter } = this.state;
    filter = {
      ...filter,
      startDate: moment(date === undefined ? new Date() : modifiedSelectedDate)
        .startOf('day')
        .toDate(),
    };
    this.setState({
      filter,
      startDate: date === undefined ? new Date() : modifiedSelectedDate,
    });
  };

  endDateChanged = (date) => {
    const selectedDate = new Date(date);
    const getCurrentYear = new Date(selectedDate).getFullYear();
    const modifiedSelectedDate = new Date(getCurrentYear, selectedDate.getMonth(), selectedDate.getDate());
    let { filter } = this.state;
    filter = {
      ...filter,
      endDate: moment(date === undefined ? new Date() : modifiedSelectedDate)
        .endOf('day')
        .toDate(),
    };
    this.setState({
      filter,
      endDate: date === undefined ? new Date() : modifiedSelectedDate,
    });
  };

  errorCallback = () => {
    this.setState({
      isDataLoading: false,
    });
  };

  successCallback = () => {
    const { limit } = this.state;
    this.setState({
      isLastPage: this.props.installationOrders.length === 0 || this.props.installationOrders.length < limit,
      isDataLoading: false,
    });
  };

  excelErrorCallback = () => {
    this.setState({
      isExcelLoading: false,
    });
  };

  excelSuccessCallback = () => {
    this.setState({
      isExcelLoading: false,
    });
  };

  fillFilterStatus = (val) => {
    switch (val) {
      case 'WEB_TO_WEB_COMPLETED':
        return ['WEB_TO_WEB_COMPLETED', 'APK_TO_WEB_COMPLETED', 'WEB_TO_APK_COMPLETED'];
      case 'WEB_TO_WEB_UNCOMPLETED':
        return ['WEB_TO_WEB_UNCOMPLETED', 'WEB_TO_APK_UNCOMPLETED', 'APK_TO_APK_UNCOMPLETED', 'APK_TO_WEB_UNCOMPLETED'];
      case 'WEB_TO_WEB_CANCELLED':
        return ['WEB_TO_WEB_CANCELLED', 'APK_TO_WEB_CANCELLED'];
      case 'WEB_TO_WEB_TIME_AGREED':
        return ['WEB_TO_WEB_TIME_AGREED', 'APK_TO_WEB_TIME_AGREED'];
      case 'WEB_TO_WEB_CUSTOMER_UNREACHABLE':
        return ['WEB_TO_WEB_CUSTOMER_UNREACHABLE', 'APK_TO_WEB_CUSTOMER_UNREACHABLE'];
      default:
        return [val];
    }
  }

  generateFilterJson = () => {
    const json = { ...this.state.filter };
    const formData = new FormData(document.forms.searchForm);
    const { filterFields } = this.state;
    filterFields.forEach((it, idx) => {
      const field = filterFields[idx].value;
      if (field === null || field === undefined) {
        return;
      }

      let value = formData.get(`filter[${it.id}].input`);
      if (field === 'status' && value === 'ALL') {
        return;
      }

      if (field === 'status') {
        value = this.fillFilterStatus(value);
      }

      if (field === 'date') {
        const { translate } = this.props;
        value = moment(value, translate('work_list.search.date_format'))
          .utcOffset(0, true)
          .toISOString();
      }

      if (value !== null) {
        json[field] = value;
      }
    });

    return json;
  };

  performExcelExport = (evt) => {
    evt.preventDefault();

    this.setState({
      isExcelLoading: true,
    });

    const json = this.generateFilterJson();
    this.props.requestInstallationOrdersAll(json, this.excelErrorCallback, this.excelSuccessCallback);
  };

  performSearch = (page) => {
    this.setState({
      isDataLoading: true,
      page,
    });

    const { limit } = this.state;
    const json = this.generateFilterJson();
    this.props.requestInstallationOrders(page, limit, json, this.errorCallback, this.successCallback);
  };

  filterData = (evt) => {
    evt.preventDefault();
    this.performSearch(1);
  };

  firstClicked = () => {
    this.performSearch(1);
  };

  prevClicked = () => {
    const { page } = this.state;
    this.performSearch(page - 1);
  };

  nextClicked = () => {
    const { page } = this.state;
    this.performSearch(page + 1);
  };

  formatDate = (date) => {
    // NB It's unclear why format 'L' with required locale doesn't work.
    const { translate } = this.props;
    return moment(date)
      .format(translate('work_list.search.date_format'));
  };

  parseDate = (str) => {
    // NB It's unclear why format 'L' with required locale doesn't work.
    const { translate } = this.props;
    const m = moment(str, translate('work_list.search.date_format'));
    if (m.isValid()) {
      return m.toDate();
    }
    return undefined;
  };

  deleteServiceSiteRow = (rowNumber) => {
    const { filterFields: rowIdsState } = this.state;

    const filterFields = rowIdsState.slice();
    filterFields.splice(rowNumber, 1);

    this.setState({
      filterFields,
    });
  };

  appendServiceReportFilterRow = () => {
    const { filterFields } = this.state;
    let { lastUsedId } = this.state;
    lastUsedId += 1;
    this.setState({
      lastUsedId,
      filterFields: [
        ...filterFields,
        {
          id: lastUsedId,
          value: null,
        },
      ],
    });
  };

  readOptions = () => {
    const { translate } = this.props;
    return [
      { label: translate('work_list.column_task.shipmentId'), value: 'shipmentId' },
      { label: translate('work_list.column_task.subcontractorName'), value: 'subcontractorName' },
      { label: translate('work_list.column_task.customerName'), value: 'customerName' },
      { label: translate('work_list.column_task.customerStreetAddress'), value: 'customerStreetAddress' },
      { label: translate('work_list.column_task.customerPostalCode'), value: 'customerPostalCode' },
      { label: translate('work_list.column_task.customerCity'), value: 'customerCity' },
      { label: translate('work_list.column_task.customerPhone'), value: 'customerPhone' },
      { label: translate('work_list.column_task.devicesName'), value: 'devicesName' },
      { label: translate('work_list.column_task.status'), value: 'status' },
      { label: translate('work_list.column_task.date'), value: 'date' },
    ];
  };

  readStatusOptions = () => {
    const { translate } = this.props;
    return [
      'ALL',
      'WEB_TO_WEB_COMPLETED',
      'WEB_TO_WEB_TIME_AGREED',
      'WEB_TO_WEB_ORDERED',
      'WEB_TO_WEB_UNCOMPLETED',
      'WEB_TO_WEB_CANCELLED',
      'WEB_TO_WEB_CUSTOMER_UNREACHABLE',
    ].map((it) => ({
      value: it,
      label: translate(`work_list.status.${it}`),
    }));
  };

  hasAlreadySelected = (current, id) => current.findIndex((it) => it.value === id) !== -1;

  renderExcelResult = () => {
    const { isExcelLoading } = this.state;
    const { translate, currentLanguage, installationOrdersAll } = this.props;
    return (
      <React.Fragment>
        {!isExcelLoading && installationOrdersAll.length > 0 && (
          <ExcelResult data={installationOrdersAll} translate={translate} language={currentLanguage} />
        )}
      </React.Fragment>
    );
  };

  renderExcelButton = () => {
    const { translate, installationOrders } = this.props;
    const { isExcelLoading, isDataLoading } = this.state;
    const title = isExcelLoading
      ? translate('work_list.search.loading')
      : translate('work_list.search.excel');
    return (
      <Button type="button"
              className="shipment-button form-button form-input-shadow"
              onClick={this.performExcelExport}
              disabled={isDataLoading || isExcelLoading || installationOrders.length === 0}>
        {isExcelLoading && (
          <i
            className="fa fa-refresh fa-spin"
            style={{ marginRight: '5px' }} />
        )}
        <span>{title}</span>
      </Button>
    );
  };

  renderSearchButton = () => {
    const { translate } = this.props;
    const { isDataLoading } = this.state;
    const title = isDataLoading
      ? translate('work_list.search.loading')
      : translate('work_list.search.btn');
    return (
      <Button disabled={isDataLoading}
              onClick={(evt) => {
                evt.preventDefault();
                this.performSearch(1);
              }}>
        {isDataLoading && (
          <i className="fa fa-refresh fa-spin"
             style={{ marginRight: '5px' }} />
        )}
        <span>{title}</span>
      </Button>
    );
  };

  renderDateSelector = () => {
    const { startDate, endDate } = this.state;
    const { translate, currentLanguage } = this.props;
    return (
      <React.Fragment>
        <DayPickerInput
          dayPickerProps={{
            locale: currentLanguage,
            localeUtils: MomentLocaleUtils,
          }}
          value={startDate}
          formatDate={this.formatDate}
          onDayChange={this.startDateChanged}
          parseDate={this.parseDate}
          placeholder={translate('work_list.search.date_format')}
          required />
        <span className="range-separator">&mdash;</span>
        <DayPickerInput
          dayPickerProps={{
            locale: currentLanguage,
            localeUtils: MomentLocaleUtils,
          }}
          value={endDate}
          formatDate={this.formatDate}
          onDayChange={this.endDateChanged}
          parseDate={this.parseDate}
          placeholder={translate('work_list.search.date_format')}
          required />
      </React.Fragment>
    );
  };

  renderFilterMainRow = () => {
    const { translate } = this.props;
    return (
      <div>
        <div className="row">
          <div className="col-sm-12">
            <label>{translate('work_list.search.label_range')}</label>
          </div>
        </div>
        <div className="row controls">
          <div className="col-sm-12 pb-1">
            {this.renderDateSelector()}
            {this.renderSearchButton()}
            {this.renderExcelButton()}
            {this.renderExcelResult()}
          </div>
        </div>
      </div>
    );
  };

  renderFormInput = (element, elementId) => {
    const { translate, currentLanguage } = this.props;

    switch (element.value) {
      case 'status':
        const statusOptions = this.readStatusOptions();
        return (
          <Select className="m-1"
                  name={`filter[${elementId}].input`}
                  data={statusOptions.map((it) => ({
                    value: it.value,
                    text: it.label,
                  }))} />
        );
      case 'date':
        return (
          <div className="form-select-input">
            <DayPickerInput formatDate={this.formatDate}
                            dayPickerProps={{
                              locale: currentLanguage,
                              localeUtils: MomentLocaleUtils,
                            }}
                            inputProps={{
                              name: `filter[${elementId}].input`,
                            }}
                            parseDate={this.parseDate}
                            placeholder={translate('work_list.search.date_format')} />
          </div>
        );
      default:
        return (
          <div className="form-select-input">
            <Input autocomplete="off"
                   className="worklist-filter-field"
                   name={`filter[${elementId}].input`}
                   placeholder={translate('service_report.search.identification')}
                   required />
          </div>
        );
    }
  };

  renderFormInputs = (elementId, id) => {
    const { translate } = this.props;
    const { filterFields } = this.state;

    const options = this.readOptions();

    return (
      <div className="row">
        <div className="col-sm-4">
          <Select placeholder={translate('work_list.search.placeholder')}
                  name={`filters[${elementId}].select`}
                  required
                  extraClass={id === 1 ? 'select_ready' : ''}
                  data={options.map((item) => ({
                    value: item.value,
                    disabled: this.hasAlreadySelected(filterFields, item.value),
                    text: item.label,
                  }))}
                  onChange={(ev) => {
                    filterFields[id].value = ev.target.value;
                    this.setState({
                      filterFields,
                    });
                  }} />
        </div>
        <div className="col-sm-8">
          {this.renderFormInput(filterFields[id], elementId)}
        </div>
      </div>
    );
  };

  renderServiceSiteRow = (element, id) => (
    <div className="order-service-site-row-filter" key={element.id}>
      <div className="fit-content">
        <h4 className="primary-color inline-block bold" style={{ paddingTop: '0.7em' }}>
          {id + 1}
        </h4>
      </div>
      <div className="order-service-site-row-inputs">
        {this.renderFormInputs(element.id, id)}
      </div>
      <div className="fit-content">
        <button type="button" className="order-service-site-row-filter-delete clickable" onClick={() => this.deleteServiceSiteRow(id)}>
          <Icon className="no-margin" src={CloseIcon} />
        </button>
      </div>
    </div>
  );

  renderFilterFields = () => {
    const { translate } = this.props;
    const { filterFields } = this.state;

    return (
      <React.Fragment>
        <div>
          <div className="col-sm-12">
            {filterFields.map((it, idx) => this.renderServiceSiteRow(it, idx))}
          </div>
        </div>

        <div>
          <div className="col-sm-12 vertical-middle clickable worklist-field" onClick={this.appendServiceReportFilterRow}>
            <Icon src={NewIcon} />
            <h6 className="primary-color inline-block bold">{translate('append_additional_filter_row')}</h6>
          </div>
        </div>
      </React.Fragment>
    );
  };

  renderNavigation = () => {
    const { page, isLastPage, isDataLoading } = this.state;
    const { translate } = this.props;

    return (
      <div>
        <div style={{ paddingBottom: '20px', paddingTop: '10px' }}>
          <div>
            <div className="col-sm-12"
                 style={{ textAlign: 'right', paddingBottom: 15 }}>
              <button className="button-link primary-color inline-block bold"
                      disabled={page === 1 || isDataLoading}
                      onClick={this.firstClicked}
                      type="button">
                {translate('work_list.search.first_page')}
              </button>
              <button className="button-link primary-color inline-block bold"
                      disabled={page === 1 || isDataLoading}
                      onClick={this.prevClicked}
                      style={{ padding: '0 0 0 15px' }}
                      type="button">
                {translate('work_list.search.previous_page')}
              </button>
              <span style={{ padding: '0 0 0 15px' }}
                    className="primary-color inline-block bold">
                {page}
              </span>
              <button className="button-link primary-color inline-block bold"
                      disabled={isLastPage || isDataLoading}
                      onClick={this.nextClicked}
                      style={{ padding: '0 0 0 15px' }}
                      type="button">
                {translate('work_list.search.next_page')}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { translate, installationOrders } = this.props;
    const { limit, isDataLoading } = this.state;

    return (
      <div>
        <div className="container">
          <div className="row" style={{ paddingTop: '10px' }} />

          <div className="row searchFilters">
            <form id="searchForm" onSubmit={this.filterData}>
              <div className="col-sm-10">
                {this.renderFilterMainRow()}
              </div>

              <div className="col-sm-10">
                {this.renderFilterFields()}
              </div>
            </form>
          </div>

          <div className="row" style={{ paddingBottom: '20px', paddingTop: '10px', paddingLeft: '30px' }}>
            <div className="tableElements">
              <div className="floatLeft">
                <div style={{ paddingRight: '4px', fontWeight: 'bold', float: 'left' }}>
                  {translate('work_list.search.rows-label')}
                </div>
                <div style={{ paddingRight: '4px', fontWeight: 'bold', float: 'left' }}>
                  <select name="limit"
                          value={limit}
                          onChange={this.limitChanged}>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
                <div style={{
                  paddingRight: '4px',
                  fontWeight: 'bold',
                  float: 'left',
                }}>
                  {translate('work_list.search.rows-suffix')}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          {this.renderNavigation()}
          <table className="report-table-container">
            <tbody>
              <tr>
                <td className="report-table-container-td">
                  <WorkTable data={installationOrders} isLoading={isDataLoading} />
                </td>
              </tr>
            </tbody>
          </table>
          {this.renderNavigation()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  translate: getTranslate(state.locale),
  installationOrders: state.workList.installationOrders,
  installationOrdersAll: state.workList.installationOrdersAll,
  currentLanguage: getActiveLanguage(state.locale).code,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  enableSubNavbar,
  setSubNavbar,
  requestInstallationOrders,
  requestInstallationOrdersAll,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WorkList);



// WEBPACK FOOTER //
// ./src/views/WorkList.js